<script setup lang="ts">
import type { EventItemTicket } from '~~/types/types'
import GroupOptionEventTicket from '~/components/reusables/GroupOptionEventTicket.vue'
import IMinus from '~/assets/images/events/icon-minus.svg?component'
import IPlus from '~/assets/images/events/icon-plus.svg?component'
import { generateEventTicketPaymentLink } from '~/composables/events/event'

const { t, n } = useI18n()

const props = defineProps<{
  privateLinkId: string | undefined
  eventTickets: EventItemTicket[]
}>()

const selected = defineModel<string>()

const { eventTickets, privateLinkId } = toRefs(props)

const eventTicketsWithChain = computed(() => {
  return eventTickets.value.map((eventTicket) => {
    const nftCollection = eventTicket.nftCollection!
    return {
      ...eventTicket,
      nftCollection,
    } as EventItemTicket & { displayPrice?: string }
  })
})

const paymentAppLink = computed(
  () =>
    selected.value &&
    generateEventTicketPaymentLink({
      eventId: selected.value,
      privateLinkId,
    })
)

// fallback
const num = ref(1)
const minus = () => {}
const plus = () => {}
</script>

<template>
  <span class="mx-3.5 mt-12.5">
    {{ t('buy-a-ticket') }}
  </span>

  <div class="px-2.5 mt-6 flex flex-col gap-2.5">
    <HeadlessRadioGroup v-model="selected">
      <div class="flex flex-col gap-y-2">
        <HeadlessRadioGroupOption
          v-slot="{ checked }"
          :value="subEvent.id"
          v-for="(subEvent, i) in eventTicketsWithChain"
          :key="subEvent.id"
        >
          <GroupOptionEventTicket :checked="checked">
            <template #title>{{ subEvent.name }}</template>
            <template #description>{{ subEvent.description }}</template>
            <template #price v-if="subEvent.displayPrice">
              {{ subEvent.displayPrice }}
            </template>
          </GroupOptionEventTicket>
        </HeadlessRadioGroupOption>
      </div>
    </HeadlessRadioGroup>
  </div>

  <div
    v-if="false"
    class="bg-black rounded-3.5 mt-4 mx-3 flex flex-col items-center px-3 py-7.5"
  >
    <div class="flex flex-row items-center gap-10">
      <button
        class="bg-[rgba(118,118,128,0.12)] w-10 h-10 rounded-full flex items-center justify-center"
        @click="minus()"
      >
        <IMinus />
      </button>
      <p class="">{{ num }}</p>
      <button
        class="bg-[rgba(118,118,128,0.12)] w-10 h-10 rounded-full flex items-center justify-center"
        @click="plus()"
      >
        <IPlus />
      </button>
    </div>
  </div>
  <div class="mx-2.5 mt-8">
    <NuxtLink
      v-if="selected"
      :to="paymentAppLink"
      class="py-3.5 rounded-full uppercase font-600 text-base tracking-wide w-full flex justify-center"
      target="_blank"
      style="background: linear-gradient(90deg, #7540ee 0%, #af55ff 100%)"
    >
      {{ t('buy-a-ticket') }}
    </NuxtLink>
  </div>
</template>
